import React, { Component } from 'react'
import { IntlProvider } from 'react-intl'
import Brief from '@src/components/AdvertisingCampaign/Social'
import { requestTranslations, requestUserInfo } from '@src/services/api'
import analytics from '@iui-kit/utils/analytics'
import { BRIEF_CREATE_START_FILLING } from '@src/constants/AdvertisingBriefs'
import { UserData } from '@src/types'

interface State {
  startedFilling: boolean
  translations: {} | undefined
  userData: UserData | null
  isLoaded: boolean
}

class BriefSocial extends Component<{}, State> {
  state = {
    startedFilling: false,
    translations: undefined,
    userData: null,
    isLoaded: false
  }

  sendStartFillingBriefAnalytics = () => {
    const { startedFilling } = this.state

    if (!startedFilling) {
      analytics.sendEvent({
        event: BRIEF_CREATE_START_FILLING
      })

      this.setState({
        startedFilling: true
      })
    }
  }

  async getTranslations() {
    const res = await requestTranslations()
    return res.data
  }

  componentDidMount() {
    this.getTranslations().then(translations => {
      this.setState({
        translations,
        isLoaded: true
      })
    })

    requestUserInfo()
      .then(response => {
        this.setState({
          userData: response.data
        })
      })
      .catch(({ response }) => {
        console.warn(response.statusText)
      })
  }

  render() {
    const { translations, isLoaded, userData } = this.state
    if (!isLoaded) {
      return null
    } else {
      return (
        <IntlProvider locale="ru" messages={translations}>
          <Brief
            userData={userData}
            sendStartFillingBriefAnalytics={this.sendStartFillingBriefAnalytics}
          />
        </IntlProvider>
      )
    }
  }
}

export default BriefSocial
